module.exports = __webpack_public_path__ + "img/art-11.76f2d2fc.png";